import { createTheme } from '@one-thd/sui-atomic-components';

const TertiaryHolidayKhaki = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

TertiaryHolidayKhaki.palette['--sui-palette-background-primary'] = '238 226 215';

export { TertiaryHolidayKhaki };